export function getUserInfo() {
    return localStorage.getItem('userInfoXcxH5')
}
export function setUserInfo(userInfo) {
    return localStorage.setItem('userInfoXcxH5',JSON.stringify(userInfo))
}
export function getToken() {
    return localStorage.getItem('token')
}
export function setToken(token) {
    return localStorage.setItem('token', token)
}
export function getUserId() {
    return localStorage.getItem('userId')
}
export function setUserId(userId) {
    return localStorage.setItem('userId', userId)
}
export function getWxCode() {
    return localStorage.getItem('wxcode')
}
export function setWxCode(wxcode) {
    return localStorage.setItem('wxcode', wxcode)
}

export function getSearchHistory() {
    return localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : []
}
export function setSearchHistory(searchHistory) {
    return localStorage.setItem('searchHistory', JSON.stringify(searchHistory))
}

export function getQuestion() {
    // return localStorage.getItem('question') ? JSON.parse(localStorage.getItem('question')).data : []
    return cache("questionv2")
}
export function setQuestion(question) {
    // return localStorage.setItem('question', JSON.stringify({ data: question }))
    return cache("questionv2", question)
    
}

export function cache(key, value) {
    if (value == null) {
        value = localStorage.getItem(key)
        if (value == null) {
            return null
        }
        value = JSON.parse(value)
        return value["data"];
    }
    localStorage.setItem(key, null)
    localStorage.setItem(key, JSON.stringify({ data: value }))
}